<main>
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    TRANSFERÊNCIA PIX
                </div>
                <p>Visualize e adicione depósitos por transferência PIX </p>
            </div>
        </div>

        <div class="separador-2"></div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 my-3">
                <form>
                    <div class="form-group">
                        <label for="inValor">Valor</label>
                        <span class="span-description">Digite o valor que você pretende depositar na sua cedente</span>
                        <input type="text" [textMask]="{mask: MASKS.currency.textMask}" class="form-control" id="inValor" #inValor>
                    </div>
                    <!-- <div class="form-group">
                        <label for="inBanco">Dado Bancário</label>
                    </div> -->

                        <button [disabled]="!inValor" type="button" class="btn btn-outline-primary" (click)="
                        depositarViaPix(modalPIX, inValor.value)
                        ">
                        Gerar QRCode
                    </button>
                </form>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row mt-5">
                <h5>Histórico :</h5>

                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0" *ngIf="true">
                            <thead class="list-table-head b-t-custom">
                                <tr>
                                    <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('solicitacaoId', sortOrder)
                                    ">
                                        Código
                                    </th>
                                    <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('descricao', sortOrder)
                                    ">
                                        Tipo
                                    </th>
                                    <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('situacao', sortOrder)
                                    ">
                                        Status
                                    </th>
                                    <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('valor', sortOrder)
                                    ">
                                        Valor
                                    </th>
                                    <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('dataCadastro', sortOrder)
                                    ">
                                        Data
                                    </th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody class="list-table-row">
                                <tr *ngFor="let solicitacao of solicitacoes" class=" list-table-cell">
                                    <td>{{ solicitacao.solicitacaoId }}</td>
                                    <td>{{ solicitacao.descricao }}</td>
                                    <td>{{ solicitacao.situacao }}</td>
                                    <td>
                                        {{ solicitacao.valor | currency: "BRL":true }}
                                    </td>
                                    <td>
                                        {{ solicitacao.dataCadastro | date: "dd/MM/yyyy" }}
                                    </td>

                                    <td>
                                        <div ngbDropdown class="d-inline-block menu-option" placement="left">
                                            <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                                <img src="assets/icons/menu.png" />
                                            </button>

                                            <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0" *ngIf="solicitacao.descricao == 'PIX' && solicitacao.situacao == 'Aguardar Pagamento'">

                                                    <!--<div ngbDropdownItem *ngIf="
                                                        solicitacao.descricao ==
                                                        'Depósito'
                                                    " (click)="
                                                        showVisualizarIntencaoDeposito(
                                                            visualizarIntencaoDeposito,
                                                            solicitacao.solicitacaoId
                                                        )
                                                    ">
                                                        <img src="assets/icons/plus-solid.png" class="mr-2" /> Ver Detalhes
                                                    </div>-->
                                                <section class="custom-context-menu" >
                                                    <div ngbDropdownItem  (click)="showQRCodePagar(modalQRCodePagar, solicitacao.solicitacaoId, solicitacao.brCodePIX)">
                                                        <img src="assets/icons/comprovante.png" class="mr-2" /> Mostrar QRCode
                                                    </div>
                                                    <div ngbDropdownItem
                                                    (click)="CancelarDeposito(solicitacao.solicitacaoId)">
                                                        <img src="assets/icons/garbage-purple.png" class="mr-2" /> Cancelar
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div *ngIf="!solicitacoes || solicitacoes?.length == 0" class="text-center">
                            <h6>
                                Nenhuma intenção de depósito encontrada
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</main>

<ng-template #modalDadosParaTransferencia let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Novo depósito
            </h5>
        </div>
    </div>
    <div class="col-md-12 clean-modal-content">
        <div class="clean-modal-align-right">
            <p class="clean-modal-text">
                Use as informações abaixo para fazer a transferência, não esqueça de usar o
                <span class="clean-modal-span">identificador
                    {{ dadosParaTransferencia.identificador }}</span
                >
                assim podemos identificar a sua transferência de forma mais
                ágil.
            </p>
            <p class="clean-modal-span">
                Identificador:
                <span class="clean-modal-text">{{
                    dadosParaTransferencia.identificador
                }}</span>
            </p>
            <p class="clean-modal-span">
                Entidade:
                <span class="clean-modal-text">{{
                    dadosParaTransferencia.instituicao
                }}</span>
            </p>
            <p class="clean-modal-span">
                Banco:
                <span class="clean-modal-text">{{
                    dadosParaTransferencia.banco
                }}</span>
            </p>
            <p class="clean-modal-span">
                Agência:
                <span class="clean-modal-text">{{
                    dadosParaTransferencia.agencia
                }}</span>
            </p>
            <p class="clean-modal-span">
                Conta Bancária:
                <span class="clean-modal-text">{{
                    dadosParaTransferencia.contaBancaria
                }}</span>
            </p>
            <p class="clean-modal-span">
                Valor:
                <span class="clean-modal-text">{{
                    dadosParaTransferencia.valor | currency: "BRL":true
                }}</span>
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="clean-modal-button-text button-cancel" type="button" (click)="modal.dismiss('Close click')">
            FECHAR
        </button>
    </div>
</ng-template>

<ng-template #visualizarIntencaoDeposito let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="modal-title clean-modal-title">
                Intenção de depósito
            </h5>
            <p class="clean-modal-subtitle">
                Visualize abaixo os dados da intenção de depósito.
            </p>
        </div>
    </div>
    <div class="col-12 clean-modal-content">
        <div class="clean-modal-section-title">Conta de origem</div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Banco:</span> {{ intencaoDepositoDetalhes.origemBancoNome }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Número do banco:</span> {{ intencaoDepositoDetalhes.origemBanco }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Agência:</span> {{ intencaoDepositoDetalhes.origemAgencia }}
            <span *ngIf="intencaoDepositoDetalhes.origemDigitoAgencia">-{{ intencaoDepositoDetalhes.origemDigitoAgencia }}</span
            >
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Conta:</span> {{ intencaoDepositoDetalhes.origemConta }}
            <span *ngIf="intencaoDepositoDetalhes.origemDigitoConta">-{{ intencaoDepositoDetalhes.origemDigitoConta }}</span
            >
        </div>

        <br />

        <div class="clean-modal-section-title">Transfira para</div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Banco:</span> {{ intencaoDepositoDetalhes.destinoBancoNome }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Número do banco:</span> {{ intencaoDepositoDetalhes.destinoBanco }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Agência:</span> {{ intencaoDepositoDetalhes.destinoAgencia }}
            <span *ngIf="intencaoDepositoDetalhes.destinoDigitoAgencia">-{{ intencaoDepositoDetalhes.destinoDigitoAgencia }}</span
            >
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Conta: </span
            >{{ intencaoDepositoDetalhes.destinoConta }}
            <span *ngIf="intencaoDepositoDetalhes.destinoDigitoConta"
                >-{{ intencaoDepositoDetalhes.destinoDigitoConta }}</span
            >
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Código de identificação:</span> {{ intencaoDepositoDetalhes.intencaoDepositoId }}
        </div>
        <div class="clean-modal-text">
            <span class="clean-modal-span">Favorecido:</span> {{ intencaoDepositoDetalhes.destinoRazaoSocial }}
        </div>
        <div class="clean-modal-text" *ngIf="
                intencaoDepositoDetalhes.origemBanco !==
                intencaoDepositoDetalhes.destinoBanco
            ">
            <span class="clean-modal-span">CNPJ:</span> {{ intencaoDepositoDetalhes.destinoCNPJ.toString() | cnpj }}
        </div>
    </div>

    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button button-cancel" type="button" (click)="modal.dismiss('Close click')">
            Fechar
        </button>
    </div>
</ng-template>

<ng-template #modalQRCodePagar let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <div class="col-12 modal-header clean-modal-header">
                <div class="col-md-12 row" style="place-content: center;">
                    <h5 class="modal-title clean-modal-title">
                        Para fazer transferência utilizar o QRCode
                    </h5>
                    <div class="col-6">
                        <img src="{{'data:image/gif;base64,' + brCodePix.imagemBRCode}}" class="qrcode-img"/>

                    </div>
                    <div class="col-6 detalhes-QRCode">
                        <h6 class="dados-qrcode-modal">Você está transferindo:</h6>
                        <span >{{brCodePix.valor | currency}}</span>
                        <h6 class="dados-qrcode-modal">Para a empresa:</h6>
                        <span > {{assignorInfo.nickName}}</span>
                        <h6 class="dados-qrcode-modal">Pagar via BRCode:</h6>
                        <span >{{brCodePix.brCode}}</span>
                    </div>
                    <!-- <p class="clean-modal-subtitle">
                        {{qrCodePix.brCode}}
                    </p> -->
                    <div class="col-12 mt-2">
                        <button class="btn btn-outline-danger btn-fechar-modal-qrcode" type="button" (click)="modal.dismiss('Close click'); BuscarSolicitacoes();">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #modalPIX let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <div class="col-12 modal-header clean-modal-header">
                <div class="col-md-12 row" style="place-content: center;">
                    <h5 class="modal-title clean-modal-title">
                        Para fazer pagamento utilizar o QRCode ou BRCode
                    </h5>
                    <div class="col-6">
                        <img src="{{'data:image/gif;base64,' + qrCodePix.imagemBRCode}}" class="qrcode-img"/>

                    </div>
                    <div class="col-6 detalhes-QRCode">
                        <h6 class="dados-qrcode-modal">Você está pagando:</h6>
                        <span >{{valorQRCode| currency}}</span>
                        <h6 class="dados-qrcode-modal">Para o estabelescimento:</h6>
                        <span > {{assignorInfo.nickName}}</span>
                        <h6 class="dados-qrcode-modal">BRCode:</h6>
                        <span >{{qrCodePix.brCode}}</span>
                    </div>
                    <!-- <p class="clean-modal-subtitle">
                        {{qrCodePix.brCode}}
                    </p> -->
                    <div class="col-12 mt-2">
                        <button class="btn btn-outline-danger btn-fechar-modal-qrcode" type="button" (click)="modal.dismiss('Close click'); BuscarSolicitacoes();">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--  -->
</ng-template>
